export enum tipoColonna {
  TESTO = 'testo',
  ICONA = 'icona',
  IMPORTO = 'importo',
  LINK = 'link',
  ARRAY = 'array'
};

